import { defineComponent as _defineComponent } from 'vue'
import {I18NGetter} from '../../services/enumTranslator/I18NGetter';

export default /*#__PURE__*/_defineComponent({
  __name: 'CopyId',
  props: {
  id: {
    type: Number,
    required: true,
  },
},
  setup(__props) {



return { __sfc: true,I18NGetter }
}

})